import { render } from "./venue-details.vue?vue&type=template&id=11bf5276"
import script from "./venue-details.vue?vue&type=script&lang=js"
export * from "./venue-details.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__